<script>
const fieldComponents = {
  text: {
    name: 'i-field-text'
  },
  datetime: {
    name: 'i-field-datetime'
  },
  number: {
    name: 'i-field-number'
  },
  timespan: {
    name: 'i-field-timespan'
  },
  enum: {
    name: 'i-field-enum'
  },
  word: {
    name: 'i-field-word'
  },
  dic: {
    name: 'i-field-dic'
  },
  boolean: {
    name: 'i-field-boolean'
  }
}
export default {
  functional: true,
  props: {
    fieldType: {
      type: String,
      default: 'text',
      validator: function (value) {
        return value in fieldComponents
      }
    }
  },
  render (createElement, { data, children, props }) {
    return createElement(fieldComponents[props.fieldType].name, data, children)
  }
}
</script>
